import { usePage } from "@inertiajs/react";
import { route as ziggyRoute } from "ziggy-js";

export default function useRoute() {
    const { props } = usePage();
    const ziggyConfig = props?.ziggy;

    return (name, params, absolute) =>
        ziggyRoute(name, params, absolute, ziggyConfig);
}
